var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.828,
    height: 16.828,
    viewBox: "0 0 16.828 16.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.193.563A1.333,1.333,0,0,1,16.364.555a2.209,2.209,0,0,1,.464,1.354A2.239,2.239,0,0,1,16.4,3.282L8.171,16.207a1.611,1.611,0,0,1-.5.452,1.288,1.288,0,0,1-.6.169,1.272,1.272,0,0,1-.607-.141,1.571,1.571,0,0,1-.515-.428L.492,9.405a2,2,0,0,1-.358-.631A2.4,2.4,0,0,1,.113,7.257a2.039,2.039,0,0,1,.34-.646,1.571,1.571,0,0,1,.514-.428,1.273,1.273,0,0,1,.606-.141,1.287,1.287,0,0,1,.6.168,1.609,1.609,0,0,1,.5.45l4.317,5.421L14.154.62A.585.585,0,0,1,14.2.563Z",
    fill: "#1d263a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.a8fc287ca7627c4681758fa0b57a5c38.svg";
export { ForwardRef as ReactComponent };